import {
  CodeBlockActions,
  CodeBlockActionTypes,
} from '../actions/codeBlockActions';
import {ApiStatus} from '../../models';

export interface ICodeBlockResult {
  blockUid: string;
  uploadingCsvStatus: ApiStatus | null;
  result: any;
  error: any;
  progress: number;
}

export interface ICodeBlockState {
  results: ICodeBlockResult[];
}

export const initialCodeBlockState: ICodeBlockState = {
  results: [],
};

function updateResult(results: ICodeBlockResult[], blockUid: string, changes: Partial<ICodeBlockResult>) {
  const existing = results.find(r => r.blockUid === blockUid);
  if (existing) {
    return results.map(r => r.blockUid === blockUid ? { ...r, ...changes } : r);
  } else {
    return [...results, { blockUid, uploadingCsvStatus: null, result: null, error: null, progress: 0, ...changes }];
  }
}

export default function codeBlockReducer(
  state: ICodeBlockState = initialCodeBlockState,
  action: CodeBlockActions
): ICodeBlockState {
  switch (action.type) {
    case CodeBlockActionTypes.UPLOAD_CSV:
    case CodeBlockActionTypes.UPLOAD_CSV_LOADING:
      return {
        ...state,
        results: updateResult(state.results, action.payload.blockUid, {
          uploadingCsvStatus: ApiStatus.LOADING,
          error: null,
          progress: 0,
        }),
      };
    case CodeBlockActionTypes.UPLOAD_CSV_PROGRESS:
      return {
        ...state,
        results: updateResult(state.results, action.payload.blockUid, {
          progress: action.payload.progress,
        }),
      };
    case CodeBlockActionTypes.UPLOAD_CSV_SUCCESS:
      return {
        ...state,
        results: updateResult(state.results, action.payload.blockUid, {
          uploadingCsvStatus: ApiStatus.LOADED,
          result: action.payload.result,
        }),
      };
    case CodeBlockActionTypes.UPLOAD_CSV_FAILED:
      return {
        ...state,
        results: updateResult(state.results, action.payload.blockUid, {
          uploadingCsvStatus: ApiStatus.FAILED,
          error: action.payload.error,
        }),
      };
    default:
      return state;
  }
}
